export default "__VITE_ASSET__Czb3Mudd__"